/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_My_ToolsInputs */

const en_directory_footer_link_my_tools = /** @type {(inputs: Directory_Footer_Link_My_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My tools`)
};

const zh_directory_footer_link_my_tools = /** @type {(inputs: Directory_Footer_Link_My_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的工具`)
};

/**
* | output |
* | --- |
* | "My tools" |
*
* @param {Directory_Footer_Link_My_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_my_tools = /** @type {((inputs?: Directory_Footer_Link_My_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_My_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_my_tools(inputs)
	return zh_directory_footer_link_my_tools(inputs)
});
export { directory_footer_link_my_tools as "directory.footer.link_my_tools" }